/* tslint:disable */

declare var Object: any;
export interface ERPtransferOrderInterface {
  "id"?: number;
}

export class ERPtransferOrder implements ERPtransferOrderInterface {
  "id": number;
  constructor(data?: ERPtransferOrderInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPtransferOrder`.
   */
  public static getModelName() {
    return "ERPtransferOrder";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPtransferOrder for dynamic purposes.
  **/
  public static factory(data: ERPtransferOrderInterface): ERPtransferOrder{
    return new ERPtransferOrder(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPtransferOrder',
      plural: 'ERPtransferOrders',
      path: 'ERPtransferOrders',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPtransferOrder.ts